// ===========================================
// McD Promo Enforcement (Production-safe, async-confirmed)
// ===========================================

const PROMO_VARIANTS = ["46653206495398", "46649959973030"]; // Bracelet + Red Pierre

async function getCart() {
  const res = await fetch("/cart.js");
  return res.json();
}

/**
 * Waits until a discount code actually exists in /cart.js before enforcing.
 * Prevents race condition with /cart/update.js response timing.
 */
async function waitForDiscountToApply(retries = 5, delay = 250) {
  for (let i = 0; i < retries; i++) {
    const cart = await getCart();
    const hasCode = Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0;
    if (hasCode) return cart;
    await new Promise((r) => setTimeout(r, delay));
  }
  // If we get here, code still hasn't landed — proceed anyway to avoid infinite loop
  return getCart();
}

async function enforcePromoRules() {
  console.log("[PromoRules] Enforcing promo rules …");

  // Wait for discount code to be committed to /cart.js
  const cart = await waitForDiscountToApply();

  const hasValidDiscount =
    cart.discount_codes?.some(
      (dc) =>
        dc.code.startsWith("MD-") ||
        dc.code.startsWith("MCA-") ||
        dc.code.startsWith("MW-")
    ) || false;

  const subtotal = cart.total_price / 100;
  console.log("[PromoRules] Cart subtotal:", subtotal);

  for (const item of cart.items) {
    if (PROMO_VARIANTS.includes(String(item.variant_id))) {
      const isPerk = String(item.variant_id) === "46653206495398"; // Bracelet
      let shouldRemove = false;

      if (!hasValidDiscount) {
        console.log("[PromoRules] No valid discount — removing promo item");
        shouldRemove = true;
      }

      if (isPerk && subtotal < 30) {
        console.log("[PromoRules] Cart subtotal below $30 — removing perk");
        shouldRemove = true;
      }

      if (shouldRemove) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });

        window.SLIDECART_UPDATE?.();
        continue;
      }

      disableQuantityControls(item.variant_id);
    }
  }

  togglePrizeUI(cart);
}

function togglePrizeUI(cart) {
  const prizePresent = cart.items.some(
    (item) => String(item.variant_id) === "46649959973030"
  );

  const rewardsEl = document.querySelector("#slidecarthq .rewards");
  const shippingEl = document.querySelector(
    "#slidecarthq .footer-row .shipping-cost"
  );

  if (prizePresent) {
    console.log("[PromoRules] Prize detected — hiding rewards + shipping cost");
    rewardsEl && (rewardsEl.style.display = "none");
    shippingEl && (shippingEl.style.display = "none");
  } else {
    rewardsEl && (rewardsEl.style.display = "");
    shippingEl && (shippingEl.style.display = "");
  }
}

function disableQuantityControls(variantId) {
  // Slide-out cart
  document.querySelectorAll(`[data-variant-id="${variantId}"]`).forEach((line) => {
    const dec = line.querySelector('button[aria-label="decrease quantity"]');
    const inc = line.querySelector('button[aria-label="increase quantity"]');
    const input = line.querySelector(".quantity-selector input[type='text']");
    if (dec) dec.disabled = true, dec.setAttribute("aria-disabled", "true");
    if (inc) inc.disabled = true, inc.setAttribute("aria-disabled", "true");
    if (input) (input.readOnly = true), (input.value = "1");
  });

  // /cart page
  document.querySelectorAll(".cart__qty-input").forEach((input) => {
    const match = input.id.match(/updates_large_(\d+)/);
    if (match && match[1] === String(variantId)) {
      input.readOnly = true;
      input.value = "1";
      input.classList.add("disabled");
    }
  });
}

// --- Throttled enforcement helper ---
let enforceTimeout;
function scheduleEnforcement(delay = 300) {
  clearTimeout(enforceTimeout);
  enforceTimeout = setTimeout(() => enforcePromoRules(), delay);
}

// --- MutationObserver with debounce ---
const observer = new MutationObserver(() => {
  scheduleEnforcement(300);
});

observer.observe(document.body, { childList: true, subtree: true });

// Initial run
document.addEventListener("DOMContentLoaded", () => {
  console.log("[PromoRules] DOM ready — enforcing promo rules …");
  enforcePromoRules();
});
